export default __webpack_public_path__ + "static/media/Combo.f41622da.jpg";